import { currencyFormat } from '@fiverr-private/localization';

interface Currency {
    name: string;
    rate: number;
}

export const getLocalizedPriceByCurrency =
    (currency: Currency) =>
    (price: number): string =>
        currencyFormat({ value: price * currency.rate, currencyCode: currency.name });
